import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import * as actions from './delivery.actions';
import { DeliveryLine, DeliveryModuleState, DeliveryState } from '../models/delivery.model';

export const adapter: EntityAdapter<DeliveryLine> = createEntityAdapter<DeliveryLine>();

export const initialState = <DeliveryModuleState>{
  delivery: adapter.getInitialState([]),
  deliveryLines: null,
  isLoaded: false,
  isUpdating: false,
};

const deliveryReducer = createReducer(
  initialState,
  on(actions.clearDeliveryState, (state) => ({
    ...state,
    delivery: null as DeliveryState,
    deliveryLines: null as DeliveryLine[],
    isLoaded: false,
  })),
  on(actions.loadDeliveriesSuccess, (state, { deliveryLines }) => ({
    ...state,
    deliveryLines,
    isLoaded: true,
  })),
  on(actions.upsertDeliveryRequest, (state) => ({ ...state, isUpdating: true })),
  on(actions.upsertDeliveryError, (state) => ({ ...state, isUpdating: false })),
  on(actions.upsertDeliverySuccess, (state, { tableLine }) => {
    const updatedLine: DeliveryLine = {
      ...state.deliveryLines?.find((line) => line.id === tableLine.id),
      flock: tableLine.flock,
      isActive: tableLine.isActive,
    };

    return {
      ...state,
      isUpdating: false,
      deliveryLines: state.deliveryLines
        ? state.deliveryLines.map((line) => (line.id === tableLine.id ? updatedLine : line))
        : [updatedLine],
    };
  }),
);

export function reducer(state: DeliveryModuleState | undefined, action: Action) {
  return deliveryReducer(state, action);
}
